<template>
  <v-list class="questionOptionsComponent">
    <v-list-item
      v-for="(option, index) in optionsCopy"
      :key="index"
      @change="$emit('newOption', optionsCopy)"
    >
      <v-list-item-action>
        <v-btn
          icon
          @click="removeOption(index)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-list-item-action>

      <v-list-item-content>
        <v-text-field
          v-model="optionsCopy[index].name"
          class="mt-0 pt-0"
          label="Option name"
          :rules="[
            ...Rules.required,
            ...Rules.max(optionsCopy[index].name, 100)
          ]"
          :counter="100"
          autofocus
        />
      </v-list-item-content>
    </v-list-item>

    <v-list-item @click="addOption">
      <v-list-item-action>
        <v-btn icon>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-list-item-action>

      <v-list-item-content>
        <v-list-item-title>New Option</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>
<script>
export default {
  name: 'QuestionOptionsComponent',
  props: {
    options: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    optionsCopy: [],
    position: 0
  }),
  computed: {
    //
  },
  created () {
    this.optionsCopy = _.cloneDeep(this.options)
    this.position = this.options.length
  },
  methods: {
    addOption () {
      this.optionsCopy.push({
        name: '',
        position: this.position
      })
      this.position++
      this.updateOptionsMissing()
    },
    removeOption (index) {
      this.optionsCopy.splice(index, 1)
      this.updateOptionsMissing()
    },
    updateOptionsMissing () {
      this.$emit('updateOptionsMissing')
    }
  }
}
</script>
<style lang="scss">
.questionOptionsComponent {
    //
}
</style>
